import { render, staticRenderFns } from "./AlbumRegister.vue?vue&type=template&id=ffea1d12&scoped=true&"
import script from "./AlbumRegister.vue?vue&type=script&lang=js&"
export * from "./AlbumRegister.vue?vue&type=script&lang=js&"
import style0 from "./AlbumRegister.vue?vue&type=style&index=0&id=ffea1d12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffea1d12",
  null
  
)

export default component.exports